import axios from 'axios'

export default {
  state: {
    lectors: [],
    themes: [],
    trainings_list: {
      all: [],
      exclusive: [],
    },
  },
  getters: {
    getTrainingsListAll: (s) => s.trainings_list.all,
    getLectors: (s) => s.lectors,
    getThemes: (s) => s.themes,
    getTrainingsListExclusive: (s) => s.trainings_list.exclusive,
  },
  mutations: {
    setTrainingsListAll: (s, list) => (s.trainings_list.all = list),
    setLectors: (s, lectors) => (s.lectors = lectors),
    setThemes: (s, themes) => (s.themes = themes),
    setTrainingsListExclusive: (s, list) => (s.trainings_list.exclusive = list),
  },
  actions: {
    fetchTrainingsList(ctx, { lang = 'ru', access, filter }) {
      let fd = ''
      for (let field in filter) {
        if (filter[field]) {
          fd += `&${field}=${filter[field]}`
        }
      }
      let exclusive = access ? '&exclusive-access=true' : ''
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `api/v3/trainings/items/?language=${lang}${exclusive}${fd}`,
      })
        .then((response) => {
          const list = response.data.results
          if (access) {
            let unique = [
              ...new Map(list.map((item) => [item.id, item])).values(),
            ]
            ctx.commit('setTrainingsListExclusive', unique)
          } else {
            let filtered = list.filter((el) => !el.access_groups.length)
            let unique = [
              ...new Map(filtered.map((item) => [item.id, item])).values(),
            ]
            ctx.commit('setTrainingsListAll', unique)
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    fetchTrainingsThemes(ctx, { lang = 'ru', access, filter }) {
      let fd = ''
      for (let field in filter) {
        if (filter[field]) {
          fd += `&${field}=${filter[field]}`
        }
      }
      let exclusive = access ? '&exclusive-access=true' : ''
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `api/v3/trainings/items/?language=${lang}${exclusive}${fd}`,
      })
        .then((response) => {
          const list = response.data.results
          if (access) {
            let unique = [
              ...new Map(list.map((item) => [item.id, item])).values(),
            ]
            ctx.commit('setThemes', unique)
          } else {
            let filtered = list.filter((el) => !el.access_groups.length)
            let unique = [
              ...new Map(filtered.map((item) => [item.id, item])).values(),
            ]
            ctx.commit('setThemes', unique)
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    fetchLectors(ctx, { lang = 'ru', access }) {
      let exclusive = access ? '&exclusive-access=true' : ''
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `/api/v3/trainings/lectors/?language=${lang}${exclusive}`,
      })
        .then((response) => {
          const list = response.data
          ctx.commit('setLectors', list)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    TrainingsSetVideoProgress(ctx, { id, progress }) {
      const fd = new FormData()
      fd.append('progress', progress)
      return axios({
        method: 'POST',
        data: fd,
        url: `/api/v3/trainings/items/${id}/progress/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    TrainingsSetLike(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/trainings/items/${id}/like/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    TrainingsSetFavorite(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/trainings/items/${id}/favorite/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    TrainingsSetView(ctx, { id, access }) {
      let exclusive = access ? '?exclusive-access=true' : ''
      return axios({
        method: 'POST',
        url: `/api/v3/trainings/items/${id}/view/${exclusive}`,
      }).catch((error) => {
        console.error(error)
      })
    },
  },
}
